const imageAndTextBordered = Object.freeze([
  {
    blockId: 23,
    size: {
      w: 10,
      h: 6
    },
    position: {
      y: 1,
      x: 1
    },
    content_type: 'asset',
    asset_type: 'photo',
    isTileCreator: true,
    blockSubtype: 'image',
    blockType: 'content',
    description: 'Add Image',
    alt_text: 'Standard image'
  },
  {
    blockId: 24,
    size: {
      w: 10,
      h: 6
    },
    position: {
      y: 1,
      x: 11
    },
    tile_caption: '<h2>Lorem ipsum dolor</h2><p>In condimentum mauris id leo varius, molestie luctus eros suscipit. Morbi a enim consectetur, fringilla ligula non</p><p><a class="secondary-button-style" href="#" target="_parent">Secondary</a></p>',
    content_type: 'text',
    blockType: 'content',
    blockSubtype: 'text',
    isTileCreator: false
  }
]);

export default imageAndTextBordered;